import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { WindowService } from '../../angular-shared/services/window/window.service';
import { AmorphicService } from '../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { WidgetCommonModule } from '../common/common.module';
import { ContactInfoService } from './services/contact-info.service';
import { ContactWidgetComponent } from './component/contact-widget-component/contact-widget.component';
import { ContactUpdateComponent } from './component/contact-update/contact-update.component';
import { ContactWidgetCoverpathComponent } from './component/contact-widget-component/contact-widget-coverpath.component';
import { ContactWidgetMmDirectComponent } from './component/contact-widget-component/contact-widget-mmdirect.component';
import { BaseFormModule } from '../../../coverpath-common/angular/components/form/base-form.module';
import { ContactUpdateCoverpathComponent } from './component/contact-update/contact-update-coverpath.component';
import { ContactUpdateMmDirectComponent } from './component/contact-update/contact-update-mmdirect.component';
import { SharedModule } from '../../../coverpath-common/angular/components/shared/shared.module';
import { LoadingModule } from '../../../coverpath-common/angular/components/shared/loading/loading.module';
import { SpinnerModule } from '../../../coverpath-common/angular/components/shared/spinner/spinner.module';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    WidgetCommonModule,
    BaseFormModule,
    SharedModule,
    LoadingModule,
    SpinnerModule,
  ],
  exports: [ContactWidgetComponent, ContactWidgetCoverpathComponent, ContactWidgetMmDirectComponent],
  declarations: [
    ContactWidgetComponent,
    ContactUpdateComponent,
    ContactWidgetCoverpathComponent,
    ContactUpdateCoverpathComponent,
    ContactWidgetMmDirectComponent,
    ContactUpdateMmDirectComponent,
  ],
  providers: [AmorphicService, WindowService, ContactInfoService],
  bootstrap: [ContactWidgetComponent, ContactWidgetCoverpathComponent, ContactWidgetMmDirectComponent],
})
export class WidgetContactUpdaterModule {}
